// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableInfinityLoader__ZfLQO {
  width: 100%;
  height: 4px;
  background-color: #fff;
  position: relative;
}
.tableInfinityLoader__ZfLQO:after {
  content: "";
  position: absolute;
  display: block;
  height: 4px;
  background-color: #3C97AA;
  left: 0;
  right: 100%;
  animation: loading__h8_37 2s ease infinite;
}

@keyframes loading__h8_37 {
  0% {
    left: 0;
    right: 100%;
  }
  50% {
    left: 0;
    right: 0;
  }
  100% {
    left: 100%;
    right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/common/TableLoading/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAzEF;AA2EE;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,OAAA;EACA,WAAA;EACA,0CAAA;AAzEN;;AA6EA;EACE;IACI,OAAA;IACA,WAAA;EA1EJ;EA4EA;IACI,OAAA;IACA,QAAA;EA1EJ;EA4EA;IACI,UAAA;IACA,QAAA;EA1EJ;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tableInfinityLoader {\n  width: 100%;\n  height: 4px;\n  background-color: #fff;\n  position: relative;\n\n  &:after {\n      content: '';\n      position: absolute;\n      display: block;\n      height: 4px;\n      background-color: #3C97AA;\n      left: 0;\n      right: 100%;\n      animation: loading 2s ease infinite;\n  }\n}\n\n@keyframes loading {\n  0% {\n      left: 0;\n      right: 100%;\n  }\n  50% {\n      left: 0;\n      right: 0;\n  }\n  100% {\n      left: 100%;\n      right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableInfinityLoader": `tableInfinityLoader__ZfLQO`,
	"loading": `loading__h8_37`
};
module.exports = ___CSS_LOADER_EXPORT___;
